module.exports = __webpack_public_path__ + "static/img/338-9.bf7497fc.jpg";